import { Route, Routes, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PublicRoutes from "./hooks/routes/public-routes";
import UserLayout from "./components/layouts/user-layout";
import { ROUTES } from "./hooks/routes/url-constant";
import { Suspense, useEffect } from "react";
import { QueryClient, QueryClientProvider } from "react-query";

import WebSiteLogout from "./hooks/routes/webSiteLogout";
import ProtectedRoutes from "./hooks/routes/protected-routes";
import AdminProtectedRoute from "./hooks/routes/adminProtected-route";
import AdminAppLogout from "./hooks/routes/adminAppLogout";
import I18nInitializer from "./components/I18next/i18next";
import AdminLayout from "./components/layouts/admin-layout";
import UserProfileLayout from "./components/layouts/userprofile-layout";

// import Registration from "./pages/WebsitePages/auth/registration/registration";
// import Login from "./pages/WebsitePages/auth/login";
// import ApplicationForm from "./pages/WebsitePages/Components/applicationForm";
// import Dashboard from "./pages/WebsitePages/Components/dashboard";
// import AdminDashboard from "./pages/AdminPages/pages/dashboard";
// import ForgetPassword from "./pages/WebsitePages/auth/forget-Password";
// import ResetPassword from "./pages/WebsitePages/auth/reset-password";
// import KendraRegistration from "./pages/WebsitePages/Components/KendraRegistration";
// import OtpVerification from "./pages/WebsitePages/auth/otp-verification";
// import PageNotFound from "./pages/AdminPages/pages/pageNotFound";
// import AdminLogin from "./pages/AdminPages/auth/AdminLogin";
// import UserList from "./pages/AdminPages/pages/userList";
// import RecruitementForm from "./pages/WebsitePages/Components/RecruitementForm";
// import Recruitment from "./pages/WebsitePages/Components/Recruitment";
// import CancleApplication from "./pages/AdminPages/pages/CancleApplication";
// import RejectApplication from "./pages/AdminPages/pages/rejectApplication";
// import ApprovedApplication from "./pages/AdminPages/pages/approvedApplication";
// import AddUser from "./pages/AdminPages/pages/addUser";
// import ViewApplication from "./pages/AdminPages/pages/viewApplication";
// import PaymentPage from "./pages/WebsitePages/Components/PaymentPage";
// import MyApplication from "./pages/WebsitePages/Components/my-application";
// import MessagePage from "./pages/WebsitePages/Components/MessagePage";
// import UserAddSuccess from "./pages/AdminPages/pages/userAddSuccess";
// import RecruitmentList from "./pages/AdminPages/pages/recruitmentList";
// import AddRecruitment from "./pages/AdminPages/pages/addRecruitment";
// import JobAddSuccess from "./pages/AdminPages/pages/jobAddSuccess";
// import Governance from "./pages/WebsitePages/Components/governance/Governance";
// import ViewResume from "./pages/AdminPages/pages/viewResume";
// import ProductPortfolio from "./pages/WebsitePages/Components/ProductPortfolio";
// import RtiAct from "./pages/WebsitePages/Components/RtiAct";
// import ContactUs from "./pages/WebsitePages/Components/ContactUs";
// import Media from "./pages/WebsitePages/Components/Media";
// import DrugLicensePage from "./pages/WebsitePages/Components/DrugLicensePage";
// import AdminForgotPassword from "./pages/AdminPages/auth/forgot-password";
// import ApplySuccessfuly from "./pages/WebsitePages/Components/apply-successfuly";
// import PmbjpScheme from "./pages/WebsitePages/Components/AboutScheme/PmbjpScheme";
// import Faq from "./pages/WebsitePages/Components/AboutScheme/Faq";
// import LocateData from "./pages/WebsitePages/Components/AboutScheme/LocateData";
// import LocateDistributor from "./pages/WebsitePages/Components/AboutScheme/LocateDistributor";
// import PmHospital from "./pages/WebsitePages/Components/AboutScheme/PmHospital";
// import AnnualReport from "./pages/WebsitePages/Components/AboutScheme/AnnualReport";
// import FinanceReport from "./pages/WebsitePages/Components/AboutScheme/FinanceReport";
// import PharmacistDetails from "./pages/WebsitePages/Components/AboutScheme/PharmacistDetails";
// import UpdateBanner from "./pages/AdminPages/pages/UpdateBanner";
// import UploadPhoto from "./pages/AdminPages/pages/UploadPhoto";
// import Tenderlist from "./pages/AdminPages/pages/Tenderlist";
// import AddProductPortfolio from "./pages/AdminPages/pages/AddProductPortfolio";
// import UpdateKendra from "./pages/AdminPages/pages/UpdateKendra";
// import NewPassword from "./pages/AdminPages/auth/new-password";
// import ChangeProfile from "./pages/AdminPages/auth/change-profile";
// import ComplitePayment from "./pages/WebsitePages/Components/complitePayment";
// import PacsTraining from "./pages/WebsitePages/Components/Support/PacsTraining";
// import PosTraining from "./pages/WebsitePages/Components/Support/PosTraining";
// import WebinarTutprial from "./pages/WebsitePages/Components/Support/WebinarTutprial";
// import KendraComplains from "./pages/WebsitePages/Components/Support/KendraComplains";
// import SugamHelpLine from "./pages/WebsitePages/Components/Support/SugamHelpLine";
// import SoftwareHelpline from "./pages/WebsitePages/Components/Support/SoftwareHelpline";
// import DownloadLink from "./pages/WebsitePages/Components/Support/DownloadLink";
// import VendorPortal from "./pages/WebsitePages/Components/Support/VendorPortal";
// import PharmacistRegistration from "./pages/WebsitePages/Components/PharmacistRegistration";
// import NewTender from "./pages/AdminPages/pages/NewTender";
// import ResumePrint from "./pages/AdminPages/pages/ResumePrint";
// import RedirectpaymentPage from "./pages/WebsitePages/Components/redirectpaymentPage";
// import Executive from "./pages/WebsitePages/Components/governance/Executive";
// import Organization from "./pages/WebsitePages/Components/governance/Organization";
// import Managements from "./pages/WebsitePages/Components/governance/Managements";
// import PharmacistList from "./pages/AdminPages/pages/PharmacistList";
// import ProductList from "./pages/AdminPages/pages/ProductList";
// import KendraList from "./pages/AdminPages/pages/KendraList";
// import ContactList from "./pages/AdminPages/pages/ContactList";
// import AddContact from "./pages/AdminPages/pages/AddContact";
// import LocatorList from "./pages/AdminPages/pages/LocatorList";
// import AdminLocateDistributor from "./pages/AdminPages/pages/Locate-Distributor";
// import CopyRight from "./pages/WebsitePages/Components/NeedHelp/copyRight";
// import HyperLinkPolicy from "./pages/WebsitePages/Components/NeedHelp/hyperLinkPolicy";
// import PrivacyPolicy from "./pages/WebsitePages/Components/NeedHelp/privacyPolicy";
// import Disclamer from "./pages/WebsitePages/Components/NeedHelp/disclamer";
// import FeedBack from "./pages/WebsitePages/Components/NeedHelp/feedBack";
// import TermsAndCondition from "./pages/WebsitePages/Components/NeedHelp/terms-and-condition";
// import NearByPharma from "./pages/WebsitePages/Components/nearByPharma";
// import NearByKendraPage from "./pages/WebsitePages/Components/nearByKendraPage";
// import AddDebarred from "./pages/AdminPages/pages/AddDebarred";
// import Testimonials from "./pages/WebsitePages/Components/Testimonials";
// import SiteMap from "./pages/WebsitePages/Components/SiteMap";
// import Tender from "./pages/WebsitePages/Components/tender/Tender";
// import Debarred from "./pages/WebsitePages/Components/tender/Debarred";
// import Awarded from "./pages/WebsitePages/Components/tender/Awarded";
// import Blacklist from "./pages/WebsitePages/Components/tender/BlackList";
// import Revocation from "./pages/WebsitePages/Components/tender/Revocation";
// import AddBlackList from "./pages/AdminPages/pages/AddBlackList";
// import AddAwardedList from "./pages/AdminPages/pages/AddAwarded";
// import AddRevocation from "./pages/AdminPages/pages/AddRevocation";
// import ManagementList from "./pages/AdminPages/pages/ManagementList";
// import AddManagament from "./pages/AdminPages/pages/AddManagament";
// import NewsList from "./pages/AdminPages/pages/NewsList";
// import AddWhatsNew from "./pages/AdminPages/pages/AddWhat'sNew";
// import AddNews from "./pages/AdminPages/pages/AddNews";
// import NewsDetail from "./pages/WebsitePages/NewsDetail";
// import ReportList from "./pages/AdminPages/pages/ReportList";
// import AddReport from "./pages/AdminPages/pages/AddReports";
// import ImageList from "./pages/AdminPages/pages/ImageList";
// import Archive from "./pages/WebsitePages/Components/Archive/Archive";
// import Debbarred from "./pages/WebsitePages/Components/Archive/Debbarred";
// import Ebroucher from "./pages/WebsitePages/Components/Archive/Ebroucher";
// import Esamvad from "./pages/WebsitePages/Components/Archive/Esamvad";
// import Others from "./pages/WebsitePages/Components/Archive/Others";
// import Reports from "./pages/WebsitePages/Components/Archive/Reports";
// import VartaEditions from "./pages/WebsitePages/Components/Archive/VartaEditions";
// import BlacklistData from "./pages/WebsitePages/Components/Archive/BlacklistData";
// import RecruitmentData from "./pages/WebsitePages/Components/Archive/RecruitmentData";
// import TenderData from "./pages/WebsitePages/Components/Archive/TenderData";
// import FinancialData from "./pages/WebsitePages/Components/Archive/FinancialData";
// import AnnualReportsData from "./pages/WebsitePages/Components/Archive/AnnualReportsData";
// import Gallery from "./pages/WebsitePages/Components/Archive/Gallery";
// import AwardedData from "./pages/WebsitePages/Components/Archive/AwardedData";
// import RevocationData from "./pages/WebsitePages/Components/Archive/RevocationData";
// import MediaList from "./pages/AdminPages/pages/MediaList";
// import ScreenRecordData from "./pages/WebsitePages/Components/ScreenRecordData";
// import GalleryMain from "./pages/WebsitePages/Components/galleryMain";
// import AddEvent from "./pages/AdminPages/pages/AddEvents";
// import ApplicationDetailsPrint from "./pages/WebsitePages/Components/applicationDetailsPrint";
// import GalleryDetails from "./pages/WebsitePages/Components/galleryDetails";
// import GalleryArchiveDetails from "./pages/WebsitePages/Components/galleryArchiveDetails";


import {
  Home,
    Registration,
    Login,
    ApplicationForm,
    Dashboard,
    AdminDashboard,
    ForgetPassword,
    ResetPassword,
    KendraRegistration,
    OtpVerification,
    PageNotFound,
    AdminLogin,
    UserList,
    RecruitementForm,
    Tender,
    Debarred,
    Awarded,
    Blacklist,
    Revocation,
    AddBlackList,
    AddAwardedList,
    AddRevocation,
    ManagementList,
    AddManagament,
    NewsList,
    AddWhatsNew,
    AddNews,
    NewsDetail,
    ReportList,
    AddReport,
    ImageList,
    Archive,
    Debbarred,
    Ebroucher,
    Esamvad,
    Others,
    Reports,
    VartaEditions,
    BlacklistData,
    RecruitmentData,
    TenderData,
    FinancialData,
    AnnualReportsData,
    Gallery,
    AwardedData,
    RevocationData,
    MediaList,
    ScreenRecordData,
    GalleryMain,
    AddEvent,
    ApplicationDetailsPrint,
    GalleryDetails,
    GalleryArchiveDetails,
    CancleApplication,
    RejectApplication,
    ApprovedApplication,
    AddUser,
    ViewApplication,
    PaymentPage,
    MyApplication,
    MessagePage,
    UserAddSuccess,
    Recruitment,
    RecruitmentList,
    AddRecruitment,
    JobAddSuccess,
    ViewResume,
    Governance,
    SiteMap,
    AddDebarred,
    Testimonials,
    TermsAndCondition,
    NearByPharma,
    NearByKendraPage,
    DownloadLink,
    VendorPortal,
    PharmacistRegistration,
    NewTender,
    ResumePrint,
    RedirectpaymentPage,
    Executive,
    Organization,
    Managements,
    PharmacistList,
    ProductList,
    KendraList,
    ContactList,
    AddContact,
    LocatorList,
    AdminLocateDistributor,
    CopyRight,
    HyperLinkPolicy,
    PrivacyPolicy,
    Disclamer,
    FeedBack,
    LocateData,
    Faq,
    PmbjpScheme,
    ApplySuccessfuly,
    AdminForgotPassword,
    DrugLicensePage,
    Media,
    ContactUs,
    RtiAct,
    ProductPortfolio,
    NewPassword,
    ChangeProfile,
    UpdateKendra,
    AddProductPortfolio,
    Tenderlist,
    UploadPhoto,
    UpdateBanner,
    PharmacistDetails,
    FinanceReport,
    AnnualReport,
    PmHospital,
    LocateDistributor,
    SoftwareHelpline,
    SugamHelpLine,
    KendraComplains,
    WebinarTutprial,
    PosTraining,
    PacsTraining,
    ComplitePayment
} from './hooks/routes/lazyLoad';
import { TableLoader } from "./components/snippets/template-blocks";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      cacheTime: 1000 * 60 * 10,
      staleTime: 1000 * 60 * 5,
    },
  },
});

function App() {

  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);


  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'F12' || event.ctrlKey && event.shiftKey && event.key === 'I') {
        event.preventDefault();
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  const handleRightClick = (e) => {
    e.preventDefault();
  };
  return (
    <div onContextMenu={handleRightClick}>

      <I18nInitializer>
        <QueryClientProvider client={queryClient}>
          <Suspense fallback={<><TableLoader/></>}>
            <Routes>
              <Route element={<UserLayout />}>
                <Route index element={<PublicRoutes component={<Home />} />} />
                <Route
                  path={ROUTES.HOMEPAGE}
                  element={<PublicRoutes component={<Home />} />}
                />

                <Route
                  path={ROUTES.APPLYFORKENDRA}
                  element={<PublicRoutes component={<Registration />} />}
                />
                <Route
                  path={ROUTES.UserProfile?.PAY_PAYMENT}
                  element={<PublicRoutes component={<PaymentPage />} />}
                />
                <Route
                  path={ROUTES.LOGINFORKENDRA}
                  element={<PublicRoutes component={<Login />} />}
                />
                <Route
                  path={ROUTES.ARCHIVE}
                  element={<PublicRoutes component={<Archive />} />}
                />

                <Route
                  path={ROUTES.ARCHIVEBLACKLIST}
                  element={<PublicRoutes component={<BlacklistData />} />}
                />
                <Route
                  path={ROUTES.ARCHIVEREVOCATION}
                  element={<PublicRoutes component={<RevocationData />} />}
                />
                <Route
                  path={ROUTES.ARCHIVEAWARDED}
                  element={<PublicRoutes component={<AwardedData />} />}
                />
                <Route
                  path={ROUTES.MAINGALLERY}
                  element={<PublicRoutes component={<GalleryMain />} />}
                />
                <Route
                  path={ROUTES.ARCHIVEDEBBAREDED}
                  element={<PublicRoutes component={<Debbarred />} />}
                />
                <Route
                  path={ROUTES.FINANCIALDATA}
                  element={<PublicRoutes component={<FinancialData />} />}
                />
                <Route
                  path={ROUTES.MAINGALLERYDETAIL}
                  element={<PublicRoutes component={<GalleryDetails />} />}
                />
                <Route
                  path={ROUTES.ARCHIVEGALLERYDETAIL}
                  element={<PublicRoutes component={<GalleryArchiveDetails />} />}
                />
                <Route
                  path={ROUTES.GALLERY}
                  element={<PublicRoutes component={<Gallery />} />}
                />
                <Route
                  path={ROUTES.ANNUALREPORTDATA}
                  element={<PublicRoutes component={<AnnualReportsData />} />}
                />
                <Route
                  path={ROUTES.EBROUCHER}
                  element={<PublicRoutes component={<Ebroucher />} />}
                />
                <Route
                  path={ROUTES.ESAMVAD}
                  element={<PublicRoutes component={<Esamvad />} />}
                />
                <Route
                  path={ROUTES.OTHERS}
                  element={<PublicRoutes component={<Others />} />}
                />
                <Route
                  path={ROUTES.ARCHIVETENDER}
                  element={<PublicRoutes component={<TenderData />} />}
                />
                <Route
                  path={ROUTES.ARCHIVERECRUITMENT}
                  element={<PublicRoutes component={<RecruitmentData />} />}
                />
                <Route
                  path={ROUTES.REPORTS}
                  element={<PublicRoutes component={<Reports />} />}
                />
                <Route
                  path={ROUTES.VERTAEDITIONS}
                  element={<PublicRoutes component={<VartaEditions />} />}
                />
                <Route
                  path={ROUTES.FORGETPASSWORD}
                  element={<PublicRoutes component={<ForgetPassword />} />}
                />
                <Route
                  path={ROUTES.RESET_PASSWORD}
                  element={<PublicRoutes component={<ResetPassword />} />}
                />
                <Route
                  path={ROUTES.OTPVERIFICATION}
                  element={<PublicRoutes component={<OtpVerification />} />}
                />
                <Route
                  path={ROUTES.SCREENRECORDER}
                  element={<PublicRoutes component={<ScreenRecordData />} />}
                />


                <Route
                  path={ROUTES.KENDRA_REGISTRATION}
                  element={<PublicRoutes component={<KendraRegistration />} />}
                />

                <Route
                  path={ROUTES.RECRUITMENT}
                  element={<PublicRoutes component={<Recruitment />} />}
                />
                <Route
                  path={ROUTES.RECRUITMENTFORM}
                  element={<PublicRoutes component={<RecruitementForm />} />}
                />
                <Route
                  path={ROUTES.GOVERNANCE}
                  element={<PublicRoutes component={<Governance />} />}
                />
                <Route
                  path={ROUTES.EXECUTIVE}
                  element={<PublicRoutes component={<Executive />} />}
                />
                <Route
                  path={ROUTES.ORGANIZATION}
                  element={<PublicRoutes component={<Organization />} />}
                />
                <Route
                  path={ROUTES.MANAGEMENT}
                  element={<PublicRoutes component={<Managements />} />}
                />

                <Route
                  path={ROUTES.PRODUCTPORTFOLIO}
                  element={<PublicRoutes component={<ProductPortfolio />} />}
                />
                <Route
                  path={ROUTES.RTIACT}
                  element={<PublicRoutes component={<RtiAct />} />}
                />

                <Route
                  path={ROUTES.MESSAGEPAGE}
                  element={<PublicRoutes component={<MessagePage />} />}
                />
                <Route
                  path={ROUTES.APPLYSUCCESSFULY}
                  element={<PublicRoutes component={<ApplySuccessfuly />} />}
                />
                <Route
                  path={ROUTES.TENDER}
                  element={<PublicRoutes component={<Tender />} />}
                />
                <Route
                  path={ROUTES.DEBBAREDLIST}
                  element={<PublicRoutes component={<Debarred />} />}
                />
                <Route
                  path={ROUTES.AWARDEDLIST}
                  element={<PublicRoutes component={<Awarded />} />}
                />
                <Route
                  path={ROUTES.BLACKLIST}
                  element={<PublicRoutes component={<Blacklist />} />}
                />
                <Route
                  path={ROUTES.REVOCATIONORDER}
                  element={<PublicRoutes component={<Revocation />} />}
                />
                <Route
                  path={ROUTES.FAQ}
                  element={<PublicRoutes component={<Faq />} />}
                />
                <Route
                  path={ROUTES.PMBJBSCHEME}
                  element={<PublicRoutes component={<PmbjpScheme />} />}
                />
                <Route
                  path={ROUTES.LOCATEKENDRA}
                  element={<PublicRoutes component={<LocateData />} />}
                />
                <Route
                  path={ROUTES.LOCATEDISTRIBUTOR}
                  element={<PublicRoutes component={<LocateDistributor />} />}
                />
                <Route
                  path={ROUTES.PMHOSPITAL}
                  element={<PublicRoutes component={<PmHospital />} />}
                />
                <Route
                  path={ROUTES.ANNUALREPORT}
                  element={<PublicRoutes component={<AnnualReport />} />}
                />
                <Route
                  path={ROUTES.FINANCEREPORT}
                  element={<PublicRoutes component={<FinanceReport />} />}
                />
                <Route
                  path={ROUTES.PHARMACISTDETAILS}
                  element={<PublicRoutes component={<PharmacistDetails />} />}
                />
                <Route
                  path={ROUTES.MEDIA}
                  element={<PublicRoutes component={<Media />} />}
                />
                <Route
                  path={ROUTES.PACSTRAINING}
                  element={<PublicRoutes component={<PacsTraining />} />}
                />
                <Route
                  path={ROUTES.NEWSDETAIL}
                  element={<PublicRoutes component={<NewsDetail />} />}
                />
                <Route
                  path={ROUTES.POSTRAINING}
                  element={<PublicRoutes component={<PosTraining />} />}
                />
                <Route
                  path={ROUTES.DOWNLOADLINK}
                  element={<PublicRoutes component={<DownloadLink />} />}
                />
                <Route
                  path={ROUTES.POSTRAINING}
                  element={<PublicRoutes component={<PosTraining />} />}
                />
                <Route
                  path={ROUTES.SOFTWAREHELPLINE}
                  element={<PublicRoutes component={<SoftwareHelpline />} />}
                />
                <Route
                  path={ROUTES.SUGAMHELPLINE}
                  element={<PublicRoutes component={<SugamHelpLine />} />}
                />
                <Route
                  path={ROUTES.KENDRACOMPLAINTS}
                  element={<PublicRoutes component={<KendraComplains />} />}
                />
                <Route
                  path={ROUTES.PHARMAREGISTER}
                  element={<PublicRoutes component={<PharmacistRegistration />} />}
                />
                <Route
                  path={ROUTES.VENDORPORTAL}
                  element={<PublicRoutes component={<VendorPortal />} />}
                />
                <Route
                  path={ROUTES.WEBINARTUTORIAL}
                  element={<PublicRoutes component={<WebinarTutprial />} />}
                />
                <Route
                  path={ROUTES.CONTACTUS}
                  element={<PublicRoutes component={<ContactUs />} />}
                />
                <Route
                  path={ROUTES.COPYRIGHT}
                  element={<PublicRoutes component={<CopyRight />} />}
                />
                <Route
                  path={ROUTES.HYPERLINKPOLICY}
                  element={<PublicRoutes component={<HyperLinkPolicy />} />}
                />
                <Route
                  path={ROUTES.PRIVACYPOLICY}
                  element={<PublicRoutes component={<PrivacyPolicy />} />}
                />
                <Route
                  path={ROUTES.DISCLAIMER}
                  element={<PublicRoutes component={<Disclamer />} />}
                />
                <Route
                  path={ROUTES.FEEDBACK}
                  element={<PublicRoutes component={<FeedBack />} />}
                />
                <Route
                  path={ROUTES.TAC}
                  element={<PublicRoutes component={<TermsAndCondition />} />}
                />
                <Route
                  path={ROUTES.SITEMAP}
                  element={<PublicRoutes component={<SiteMap />} />}
                />

                <Route
                  path={ROUTES.TESTIMONIALS}
                  element={<PublicRoutes component={<Testimonials />} />}
                />


                <Route
                  path={ROUTES.NEARBYPHARMA}
                  element={<PublicRoutes component={<NearByPharma />} />}
                />
                <Route
                  path={ROUTES.NEARBYKENDRA}
                  element={<PublicRoutes component={<NearByKendraPage />} />}
                />
              </Route>
              <Route
                path={ROUTES.MESSAGEPAGE}
                element={<PublicRoutes component={<MessagePage />} />}
              />
              <Route
                path={ROUTES.APPLYSUCCESSFULY}
                element={<PublicRoutes component={<ApplySuccessfuly />} />}
              />
              <Route
                path={ROUTES.TENDER}
                element={<PublicRoutes component={<Tender />} />}
              />
              <Route
                path={ROUTES.DEBBAREDLIST}
                element={<PublicRoutes component={<Debarred />} />}
              />
              <Route
                path={ROUTES.AWARDEDLIST}
                element={<PublicRoutes component={<Awarded />} />}
              />
              <Route
                path={ROUTES.BLACKLIST}
                element={<PublicRoutes component={<Blacklist />} />}
              />
              <Route
                path={ROUTES.REVOCATIONORDER}
                element={<PublicRoutes component={<Revocation />} />}
              />
              <Route
                path={ROUTES.FAQ}
                element={<PublicRoutes component={<Faq />} />}
              />
              <Route
                path={ROUTES.PMBJBSCHEME}
                element={<PublicRoutes component={<PmbjpScheme />} />}
              />
              <Route
                path={ROUTES.LOCATEKENDRA}
                element={<PublicRoutes component={<LocateData />} />}
              />
              <Route
                path={ROUTES.LOCATEDISTRIBUTOR}
                element={<PublicRoutes component={<LocateDistributor />} />}
              />
              <Route
                path={ROUTES.PMHOSPITAL}
                element={<PublicRoutes component={<PmHospital />} />}
              />
              <Route
                path={ROUTES.ANNUALREPORT}
                element={<PublicRoutes component={<AnnualReport />} />}
              />
              <Route
                path={ROUTES.FINANCEREPORT}
                element={<PublicRoutes component={<FinanceReport />} />}
              />
              <Route
                path={ROUTES.PHARMACISTDETAILS}
                element={<PublicRoutes component={<PharmacistDetails />} />}
              />
              <Route
                path={ROUTES.MEDIA}
                element={<PublicRoutes component={<Media />} />}
              />
              <Route
                path={ROUTES.PACSTRAINING}
                element={<PublicRoutes component={<PacsTraining />} />}
              />
              <Route
                path={ROUTES.POSTRAINING}
                element={<PublicRoutes component={<PosTraining />} />}
              />
              <Route
                path={ROUTES.DOWNLOADLINK}
                element={<PublicRoutes component={<DownloadLink />} />}
              />
              <Route
                path={ROUTES.POSTRAINING}
                element={<PublicRoutes component={<PosTraining />} />}
              />
              <Route
                path={ROUTES.SOFTWAREHELPLINE}
                element={<PublicRoutes component={<SoftwareHelpline />} />}
              />
              <Route
                path={ROUTES.SUGAMHELPLINE}
                element={<PublicRoutes component={<SugamHelpLine />} />}
              />
              <Route
                path={ROUTES.KENDRACOMPLAINTS}
                element={<PublicRoutes component={<KendraComplains />} />}
              />
              <Route
                path={ROUTES.PHARMAREGISTER}
                element={<PublicRoutes component={<PharmacistRegistration />} />}
              />
              <Route
                path={ROUTES.VENDORPORTAL}
                element={<PublicRoutes component={<VendorPortal />} />}
              />
              <Route
                path={ROUTES.WEBINARTUTORIAL}
                element={<PublicRoutes component={<WebinarTutprial />} />}
              />
              <Route
                path={ROUTES.CONTACTUS}
                element={<PublicRoutes component={<ContactUs />} />}
              />



              <Route
                path={ROUTES.COPYRIGHT}
                element={<PublicRoutes component={<CopyRight />} />}
              />
              <Route
                path={ROUTES.HYPERLINKPOLICY}
                element={<PublicRoutes component={<HyperLinkPolicy />} />}
              />
              <Route
                path={ROUTES.PRIVACYPOLICY}
                element={<PublicRoutes component={<PrivacyPolicy />} />}
              />
              <Route
                path={ROUTES.DISCLAIMER}
                element={<PublicRoutes component={<Disclamer />} />}
              />
              <Route
                path={ROUTES.FEEDBACK}
                element={<PublicRoutes component={<FeedBack />} />}
              />
              <Route
                path={ROUTES.TAC}
                element={<PublicRoutes component={<TermsAndCondition />} />}
              />
              <Route
                path={ROUTES.SITEMAP}
                element={<PublicRoutes component={<SiteMap />} />}
              />

              <Route
                path={ROUTES.TESTIMONIALS}
                element={<PublicRoutes component={<Testimonials />} />}
              />


              <Route
                path={ROUTES.NEARBYPHARMA}
                element={<PublicRoutes component={<NearByPharma />} />}
              />
              <Route
                path={ROUTES.NEARBYKENDRA}
                element={<PublicRoutes component={<NearByKendraPage />} />}
              />
              <Route
                path={ROUTES.NEWSDETAIL}
                element={<PublicRoutes component={<NewsDetail />} />}
              />
              <Route
                path={ROUTES?.UserProfile?.APPLICATION_FORM_PRINT}
                element={
                  <ProtectedRoutes
                    component={
                      <>
                        <WebSiteLogout>
                          <ApplicationDetailsPrint />
                        </WebSiteLogout>
                      </>
                    }
                  />
                }
              />




              {/* -------------------------------- */}
              <Route element={<UserProfileLayout />}>
                <Route
                  index
                  path={ROUTES?.UserProfile?.DASHBOARD}
                  element={
                    <ProtectedRoutes
                      component={
                        <>
                          <WebSiteLogout>
                            <Dashboard />
                          </WebSiteLogout>
                        </>
                      }
                    />
                  }
                />
                <Route
                  path={ROUTES?.UserProfile?.MY_APPLICATION}
                  element={
                    <ProtectedRoutes
                      component={
                        <>
                          <WebSiteLogout>
                            <MyApplication />
                          </WebSiteLogout>
                        </>
                      }
                    />
                  }
                />
                <Route
                  path={ROUTES?.UserProfile?.DRUGLICENSEPAGE}
                  element={
                    <ProtectedRoutes
                      component={
                        <>
                          <WebSiteLogout>
                            <DrugLicensePage />
                          </WebSiteLogout>
                        </>
                      }
                    />
                  }
                />
                <Route
                  path={ROUTES?.UserProfile?.APPLICATION_FORM}
                  element={
                    <ProtectedRoutes
                      component={
                        <>
                          <WebSiteLogout>
                            <ApplicationForm />
                          </WebSiteLogout>
                        </>
                      }
                    />
                  }
                />

                <Route
                  path={ROUTES?.UserProfile?.PAYMENTPAGE}
                  element={
                    <ProtectedRoutes
                      component={
                        <>
                          <WebSiteLogout>
                            <PaymentPage />
                          </WebSiteLogout>
                        </>
                      }
                    />
                  }
                />
              </Route>

              {/* Admin Routes Start */}
              <Route path={ROUTES?.ADMIN.ADMIN_LOGIN} element={<AdminLogin />} />
              <Route
                path={ROUTES?.ADMIN.ADMIN_FORGOT}
                element={<AdminForgotPassword />}
              />
              <Route
                path={ROUTES?.ADMIN.REJECT_REASON_APPLICATION}
                element={<AdminProtectedRoute component={<CancleApplication />} />}
              />
              <Route
                path={ROUTES?.ADMIN.PASSWORD_CHANGE}
                element={<AdminProtectedRoute component={<NewPassword />} />}
              />
              <Route
                path={ROUTES?.ADMIN.PROFILE_CHANGE}
                element={<AdminProtectedRoute component={<ChangeProfile />} />}
              />
              <Route
                path={ROUTES?.ADMIN.REJECT_APPLICATION}
                element={<AdminProtectedRoute component={<RejectApplication />} />}
              />
              <Route
                path={ROUTES?.ADMIN.APPROVE_APPLICATION}
                element={
                  <AdminProtectedRoute component={<ApprovedApplication />} />
                }
              />

              <Route
                path={ROUTES?.ADMIN.USER_ADDED_SUCCESS}
                element={<AdminProtectedRoute component={<UserAddSuccess />} />}
              />

              <Route
                path={ROUTES?.ADMIN.JOB_ADDED_SUCCESS}
                element={<AdminProtectedRoute component={<JobAddSuccess />} />}
              />

              <Route
                path={ROUTES?.ADMIN.RESUME_PRINT}
                element={<AdminProtectedRoute component={<ResumePrint />} />}
              />
              <Route
                path={process.env.PUBLIC_URL + "/admin"}
                element={<AdminLayout />}
              >
                <Route
                  index
                  path={ROUTES?.ADMIN.DASHBOARD}
                  element={
                    <AdminProtectedRoute
                      component={
                        <>
                          <AdminAppLogout>
                            <AdminDashboard />
                          </AdminAppLogout>
                        </>
                      }
                    />
                  }
                />
                <Route
                  path={ROUTES?.ADMIN.VIEW_APPLICATION}
                  element={
                    <AdminProtectedRoute
                      component={
                        <>
                          {" "}
                          <AdminAppLogout>
                            <ViewApplication />
                          </AdminAppLogout>
                        </>
                      }
                    />
                  }
                />

                <Route
                  path={ROUTES?.ADMIN.USER_LIST}
                  element={
                    <AdminProtectedRoute
                      component={
                        <>
                          <AdminAppLogout>
                            <UserList />
                          </AdminAppLogout>
                        </>
                      }
                    />
                  }
                />

                <Route
                  path={ROUTES?.ADMIN.ADD_USER}
                  element={
                    <AdminProtectedRoute
                      component={
                        <>
                          <AdminAppLogout>
                            <AddUser />
                          </AdminAppLogout>
                        </>
                      }
                    />
                  }
                />

                <Route
                  path={ROUTES?.ADMIN.RECRUITMENT_LIST}
                  element={
                    <AdminProtectedRoute
                      component={
                        <>
                          <AdminAppLogout>
                            <RecruitmentList />
                          </AdminAppLogout>
                        </>
                      }
                    />
                  }
                />
                <Route
                  path={ROUTES?.ADMIN.ADD_JOB}
                  element={
                    <AdminProtectedRoute
                      component={
                        <>
                          <AdminAppLogout>
                            <AddRecruitment />
                          </AdminAppLogout>
                        </>
                      }
                    />
                  }
                />

                <Route
                  path={ROUTES?.ADMIN.VIEW_RESUME}
                  element={<AdminProtectedRoute component={<ViewResume />} />}
                />
                <Route
                  path={ROUTES?.ADMIN.UPDATE_BANNER}
                  element={<AdminProtectedRoute component={<UpdateBanner />} />}
                />

                <Route
                  path={ROUTES?.ADMIN.UPLOAD_PHOTO}
                  element={<AdminProtectedRoute component={<UploadPhoto />} />}
                />
                <Route
                  path={ROUTES?.ADMIN.TENDER_ADD}
                  element={<AdminProtectedRoute component={<NewTender />} />}
                />
                <Route
                  path={ROUTES?.ADMIN.TENDER_DEBARRED}
                  element={<AdminProtectedRoute component={<AddDebarred />} />}
                />
                <Route
                  path={ROUTES?.ADMIN.TENDER_REVOCATION}
                  element={<AdminProtectedRoute component={<AddRevocation />} />}
                />
                <Route
                  path={ROUTES?.ADMIN.TENDER_BLACKLIST}
                  element={<AdminProtectedRoute component={<AddBlackList />} />}
                />
                <Route
                  path={ROUTES?.ADMIN.TENDER_AWARDED}
                  element={<AdminProtectedRoute component={<AddAwardedList />} />}
                />
                <Route
                  path={ROUTES?.ADMIN.TENDER_ADMIN}
                  element={<AdminProtectedRoute component={<Tenderlist />} />}
                />

                <Route
                  path={ROUTES?.ADMIN.ADD_PRODUCTPORTFOLIO}
                  element={
                    <AdminProtectedRoute component={<AddProductPortfolio />} />
                  }
                />
                <Route
                  path={ROUTES?.ADMIN.UPDATE_KENDRADATA}
                  element={<AdminProtectedRoute component={<UpdateKendra />} />}
                />
                <Route
                  path={ROUTES?.ADMIN.LOCATE_DISTRIBUTOR}
                  element={
                    <AdminProtectedRoute component={<LocateDistributor />} />
                  }
                />

                {/* pharmacist route */}
                <Route
                  path={ROUTES?.ADMIN.PHARMACIST_LIST}
                  element={<AdminProtectedRoute component={<PharmacistList />} />}
                />
              </Route>
              {/* Admin Routes End */}
              <Route
                path={ROUTES?.COMPLETEPAYMENT}
                element={<ProtectedRoutes component={<ComplitePayment />} />}
              />
              <Route
                path={ROUTES?.REZORPAYPAGE}
                element={<ProtectedRoutes component={<RedirectpaymentPage />} />}
              />
              <Route path="*" element={<PageNotFound />} />
              {/* Admin Routes Start */}
              <Route path={ROUTES?.ADMIN.ADMIN_LOGIN} element={<AdminLogin />} />
              <Route
                path={ROUTES?.ADMIN.ADMIN_FORGOT}
                element={<AdminForgotPassword />}
              />
              <Route
                path={ROUTES?.ADMIN.REJECT_REASON_APPLICATION}
                element={<AdminProtectedRoute component={<CancleApplication />} />}
              />
              <Route
                path={ROUTES?.ADMIN.PASSWORD_CHANGE}
                element={<AdminProtectedRoute component={<NewPassword />} />}
              />
              <Route
                path={ROUTES?.ADMIN.PROFILE_CHANGE}
                element={<AdminProtectedRoute component={<ChangeProfile />} />}
              />
              <Route
                path={ROUTES?.ADMIN.REJECT_APPLICATION}
                element={<AdminProtectedRoute component={<RejectApplication />} />}
              />
              <Route
                path={ROUTES?.ADMIN.APPROVE_APPLICATION}
                element={
                  <AdminProtectedRoute component={<ApprovedApplication />} />
                }
              />

              <Route
                path={ROUTES?.ADMIN.USER_ADDED_SUCCESS}
                element={<AdminProtectedRoute component={<UserAddSuccess />} />}
              />

              <Route
                path={ROUTES?.ADMIN.JOB_ADDED_SUCCESS}
                element={<AdminProtectedRoute component={<JobAddSuccess />} />}
              />

              <Route
                path={ROUTES?.ADMIN.RESUME_PRINT}
                element={<AdminProtectedRoute component={<ResumePrint />} />}
              />
              <Route
                path={process.env.PUBLIC_URL + "/admin"}
                element={<AdminLayout />}
              >
                <Route
                  index
                  path={ROUTES?.ADMIN.DASHBOARD}
                  element={
                    <AdminProtectedRoute
                      component={
                        <>
                          <AdminAppLogout>
                            <AdminDashboard />
                          </AdminAppLogout>
                        </>
                      }
                    />
                  }
                />
                <Route
                  path={ROUTES?.ADMIN.VIEW_APPLICATION}
                  element={
                    <AdminProtectedRoute
                      component={
                        <>
                          {" "}
                          <AdminAppLogout>
                            <ViewApplication />
                          </AdminAppLogout>
                        </>
                      }
                    />
                  }
                />
                <Route
                  path={ROUTES?.ADMIN.USER_LIST}
                  element={
                    <AdminProtectedRoute
                      component={
                        <>
                          <AdminAppLogout>
                            <UserList />
                          </AdminAppLogout>
                        </>
                      }
                    />
                  }
                />
                <Route
                  path={ROUTES?.ADMIN.ADD_USER}
                  element={
                    <AdminProtectedRoute
                      component={
                        <>
                          <AdminAppLogout>
                            <AddUser />
                          </AdminAppLogout>
                        </>
                      }
                    />
                  }
                />
                <Route
                  path={ROUTES?.ADMIN.RECRUITMENT_LIST}
                  element={
                    <AdminProtectedRoute
                      component={
                        <>
                          <AdminAppLogout>
                            <RecruitmentList />
                          </AdminAppLogout>
                        </>
                      }
                    />
                  }
                />
                <Route
                  path={ROUTES?.ADMIN.ADD_JOB}
                  element={
                    <AdminProtectedRoute
                      component={
                        <>
                          <AdminAppLogout>
                            <AddRecruitment />
                          </AdminAppLogout>
                        </>
                      }
                    />
                  }
                />
                <Route
                  path={ROUTES?.ADMIN.VIEW_RESUME}
                  element={<AdminProtectedRoute component={<ViewResume />} />}
                />
                <Route
                  path={ROUTES?.ADMIN.UPDATE_BANNER}
                  element={<AdminProtectedRoute component={<UpdateBanner />} />}
                />
                <Route
                  path={ROUTES?.ADMIN.UPLOAD_PHOTO}
                  element={<AdminProtectedRoute component={<UploadPhoto />} />}
                />
                <Route
                  path={ROUTES?.ADMIN.TENDER_ADD}
                  element={
                    <AdminProtectedRoute component={<NewTender form="Add" />} />
                  }
                />
                <Route
                  path={ROUTES?.ADMIN.TENDER_ADMIN}
                  element={<AdminProtectedRoute component={<Tenderlist />} />}
                />
                <Route
                  path={ROUTES?.ADMIN.ADD_PRODUCTPORTFOLIO}
                  element={
                    <AdminProtectedRoute component={<AddProductPortfolio />} />
                  }
                />
                <Route
                  path={ROUTES?.ADMIN.LIST_PRODUCTPORTFOLIO}
                  element={<AdminProtectedRoute component={<ProductList />} />}
                />

                <Route
                  path={ROUTES?.ADMIN.ADD_CONTACT}
                  element={<AdminProtectedRoute component={<AddContact />} />}
                />
                <Route
                  path={ROUTES?.ADMIN.LIST_CONTACT}
                  element={<AdminProtectedRoute component={<ContactList />} />}
                />
                <Route
                  path={ROUTES?.ADMIN.LIST_KENDRADATA}
                  element={<AdminProtectedRoute component={<KendraList />} />}
                />
                <Route
                  path={ROUTES?.ADMIN.UPDATE_KENDRADATA}
                  element={<AdminProtectedRoute component={<UpdateKendra />} />}
                />
                <Route
                  path={ROUTES?.ADMIN.LIST_LOCATE_DISTRIBUTOR}
                  element={<AdminProtectedRoute component={<LocatorList />} />}
                />
                <Route
                  path={ROUTES?.ADMIN.ADD_LOCATE_DISTRIBUTOR}
                  element={
                    <AdminProtectedRoute component={<AdminLocateDistributor />} />
                  }
                />
                {/* pharmacist route */}
                <Route
                  path={ROUTES?.ADMIN.PHARMACIST_LIST}
                  element={<AdminProtectedRoute component={<PharmacistList />} />}
                />
              </Route>
              {/* Admin Routes End */}
              <Route
                path={ROUTES?.COMPLETEPAYMENT}
                element={<ProtectedRoutes component={<ComplitePayment />} />}
              />
              <Route
                path={ROUTES?.REZORPAYPAGE}
                element={<ProtectedRoutes component={<RedirectpaymentPage />} />}
              />
              <Route
                path={ROUTES?.ADMIN.UPLOAD_PHOTO}
                element={<AdminProtectedRoute component={<UploadPhoto />} />}
              />
              <Route
                path={ROUTES?.ADMIN.TENDER_ADD}
                element={<AdminProtectedRoute component={<NewTender />} />}
              />
              <Route
                path={ROUTES?.ADMIN.TENDER_DEBARRED}
                element={<AdminProtectedRoute component={<AddDebarred />} />}
              />
              <Route
                path={ROUTES?.ADMIN.TENDER_REVOCATION}
                element={<AdminProtectedRoute component={<AddRevocation />} />}
              />
              <Route
                path={ROUTES?.ADMIN.TENDER_BLACKLIST}
                element={<AdminProtectedRoute component={<AddBlackList />} />}
              />
              <Route
                path={ROUTES?.ADMIN.TENDER_AWARDED}
                element={<AdminProtectedRoute component={<AddAwardedList />} />}
              />
              <Route
                path={ROUTES?.ADMIN.TENDER_ADMIN}
                element={<AdminProtectedRoute component={<Tenderlist />} />}
              />

              <Route
                path={ROUTES?.ADMIN.ADD_PRODUCTPORTFOLIO}
                element={
                  <AdminProtectedRoute component={<AddProductPortfolio />} />
                }
              />
              <Route
                path={ROUTES?.ADMIN.UPDATE_KENDRADATA}
                element={<AdminProtectedRoute component={<UpdateKendra />} />}
              />
              <Route
                path={ROUTES?.ADMIN.LOCATE_DISTRIBUTOR}
                element={
                  <AdminProtectedRoute component={<LocateDistributor />} />
                }
              />

              {/* pharmacist route */}
              <Route
                path={ROUTES?.ADMIN.PHARMACIST_LIST}
                element={<AdminProtectedRoute component={<PharmacistList />} />}
              />

              {/* Admin Routes End */}
              <Route
                path={ROUTES?.COMPLETEPAYMENT}
                element={<ProtectedRoutes component={<ComplitePayment />} />}
              />
              <Route
                path={ROUTES?.REZORPAYPAGE}
                element={<ProtectedRoutes component={<RedirectpaymentPage />} />}
              />
              <Route path="*" element={<PageNotFound />} />
              {/* Admin Routes Start */}
              <Route path={ROUTES?.ADMIN.ADMIN_LOGIN} element={<AdminLogin />} />
              <Route
                path={ROUTES?.ADMIN.ADMIN_FORGOT}
                element={<AdminForgotPassword />}
              />
              <Route
                path={ROUTES?.ADMIN.REJECT_REASON_APPLICATION}
                element={<AdminProtectedRoute component={<CancleApplication />} />}
              />
              <Route
                path={ROUTES?.ADMIN.PASSWORD_CHANGE}
                element={<AdminProtectedRoute component={<NewPassword />} />}
              />
              <Route
                path={ROUTES?.ADMIN.PROFILE_CHANGE}
                element={<AdminProtectedRoute component={<ChangeProfile />} />}
              />
              <Route
                path={ROUTES?.ADMIN.REJECT_APPLICATION}
                element={<AdminProtectedRoute component={<RejectApplication />} />}
              />
              <Route
                path={ROUTES?.ADMIN.APPROVE_APPLICATION}
                element={
                  <AdminProtectedRoute component={<ApprovedApplication />} />
                }
              />

              <Route
                path={ROUTES?.ADMIN.USER_ADDED_SUCCESS}
                element={<AdminProtectedRoute component={<UserAddSuccess />} />}
              />

              <Route
                path={ROUTES?.ADMIN.JOB_ADDED_SUCCESS}
                element={<AdminProtectedRoute component={<JobAddSuccess />} />}
              />

              <Route
                path={ROUTES?.ADMIN.RESUME_PRINT}
                element={<AdminProtectedRoute component={<ResumePrint />} />}
              />

              <Route
                path={ROUTES?.ADMIN.APPLICATION_FORM_PRINT}
                element={<AdminProtectedRoute component={<ApplicationDetailsPrint />} />}
              />

              <Route
                path={process.env.PUBLIC_URL + "/admin"}
                element={<AdminLayout />}
              >
                <Route
                  index
                  path={ROUTES?.ADMIN.DASHBOARD}
                  element={
                    <AdminProtectedRoute
                      component={
                        <>
                          <AdminAppLogout>
                            <AdminDashboard />
                          </AdminAppLogout>
                        </>
                      }
                    />
                  }
                />
                <Route
                  path={ROUTES?.ADMIN.VIEW_APPLICATION}
                  element={
                    <AdminProtectedRoute
                      component={
                        <>
                          {" "}
                          <AdminAppLogout>
                            <ViewApplication />
                          </AdminAppLogout>
                        </>
                      }
                    />
                  }
                />
                <Route
                  path={ROUTES?.ADMIN.USER_LIST}
                  element={
                    <AdminProtectedRoute
                      component={
                        <>
                          <AdminAppLogout>
                            <UserList />
                          </AdminAppLogout>
                        </>
                      }
                    />
                  }
                />
                <Route
                  path={ROUTES?.ADMIN.ADD_USER}
                  element={
                    <AdminProtectedRoute
                      component={
                        <>
                          <AdminAppLogout>
                            <AddUser />
                          </AdminAppLogout>
                        </>
                      }
                    />
                  }
                />
                <Route
                  path={ROUTES?.ADMIN.RECRUITMENT_LIST}
                  element={
                    <AdminProtectedRoute
                      component={
                        <>
                          <AdminAppLogout>
                            <RecruitmentList />
                          </AdminAppLogout>
                        </>
                      }
                    />
                  }
                />
                <Route
                  path={ROUTES?.ADMIN.ADD_JOB}
                  element={
                    <AdminProtectedRoute
                      component={
                        <>
                          <AdminAppLogout>
                            <AddRecruitment />
                          </AdminAppLogout>
                        </>
                      }
                    />
                  }
                />
                {/* <Route
                path={ROUTES?.ADMIN.VIEW_RESUME}
                element={<AdminProtectedRoute component={<ApplicationDetailsPrint />} />}
              /> */}


                {/* <Route
                path={ROUTES?.ADMIN?.APPLICATION_FORM_PRINT}
                element={<AdminProtectedRoute component={<ApplicationDetailsPrint />} />}
              /> */}


                <Route
                  path={ROUTES?.ADMIN.UPDATE_BANNER}
                  element={<AdminProtectedRoute component={<UpdateBanner />} />}
                />
                <Route
                  path={ROUTES?.ADMIN.UPLOAD_PHOTO}
                  element={<AdminProtectedRoute component={<UploadPhoto />} />}
                />
                <Route
                  path={ROUTES?.ADMIN.IMAGE_LIST}
                  element={<AdminProtectedRoute component={<ImageList />} />}
                />
                <Route
                  path={ROUTES?.ADMIN.TENDER_ADD}
                  element={
                    <AdminProtectedRoute component={<NewTender form="Add" />} />
                  }
                />
                <Route
                  path={ROUTES?.ADMIN.TENDER_ADMIN}
                  element={<AdminProtectedRoute component={<Tenderlist />} />}
                />
                <Route
                  path={ROUTES?.ADMIN.ADD_PRODUCTPORTFOLIO}
                  element={
                    <AdminProtectedRoute component={<AddProductPortfolio />} />
                  }
                />
                <Route
                  path={ROUTES?.ADMIN.LIST_PRODUCTPORTFOLIO}
                  element={<AdminProtectedRoute component={<ProductList />} />}
                />

                <Route
                  path={ROUTES?.ADMIN.ADD_CONTACT}
                  element={<AdminProtectedRoute component={<AddContact />} />}
                />
                <Route
                  path={ROUTES?.ADMIN.LIST_CONTACT}
                  element={<AdminProtectedRoute component={<ContactList />} />}
                />
                <Route
                  path={ROUTES?.ADMIN.LIST_KENDRADATA}
                  element={<AdminProtectedRoute component={<KendraList />} />}
                />
                <Route
                  path={ROUTES?.ADMIN.UPDATE_KENDRADATA}
                  element={<AdminProtectedRoute component={<UpdateKendra />} />}
                />
                <Route
                  path={ROUTES?.ADMIN.LIST_LOCATE_DISTRIBUTOR}
                  element={<AdminProtectedRoute component={<LocatorList />} />}
                />
                <Route
                  path={ROUTES?.ADMIN.ADD_LOCATE_DISTRIBUTOR}
                  element={
                    <AdminProtectedRoute component={<AdminLocateDistributor />} />
                  }
                />

                <Route
                  path={ROUTES?.ADMIN.MANAGAMENT_LIST}
                  element={
                    <AdminProtectedRoute component={<ManagementList />} />
                  }
                />
                <Route
                  path={ROUTES?.ADMIN.ADD_MANAGAMENT}
                  element={
                    <AdminProtectedRoute component={<AddManagament />} />
                  }
                />

                <Route
                  path={ROUTES?.ADMIN.NEWS_LIST}
                  element={
                    <AdminProtectedRoute component={<NewsList />} />
                  }
                />

                <Route
                  path={ROUTES?.ADMIN.ADD_WHATS_NEW}
                  element={
                    <AdminProtectedRoute component={<AddWhatsNew />} />
                  }
                />
                <Route
                  path={ROUTES?.ADMIN.ADD_NEWS_LETTER}
                  element={
                    <AdminProtectedRoute component={<AddNews />} />
                  }
                />


                <Route
                  path={ROUTES?.ADMIN.MEDIA_LIST}
                  element={
                    <AdminProtectedRoute component={<MediaList />} />
                  }
                />
                <Route
                  path={ROUTES?.ADMIN.ADD_EVENT}
                  element={
                    <AdminProtectedRoute component={<AddEvent />} />
                  }
                />


                <Route
                  path={ROUTES?.ADMIN.REPORT_LIST}
                  element={
                    <AdminProtectedRoute component={<ReportList />} />
                  }
                />




                <Route
                  path={ROUTES?.ADMIN.ADD_REPORT}
                  element={
                    <AdminProtectedRoute component={<AddReport />} />
                  }
                />
                {/* pharmacist route */}
                <Route
                  path={ROUTES?.ADMIN.PHARMACIST_LIST}
                  element={<AdminProtectedRoute component={<PharmacistList />} />}
                />
              </Route>




              {/* Admin Routes End */}
              <Route
                path={ROUTES?.COMPLETEPAYMENT}
                element={<ProtectedRoutes component={<ComplitePayment />} />}
              />
              <Route
                path={ROUTES?.REZORPAYPAGE}
                element={<ProtectedRoutes component={<RedirectpaymentPage />} />}
              />
              <Route path="*" element={<PageNotFound />} />
            </Routes>
          </Suspense>
        </QueryClientProvider>
      </I18nInitializer>

      <ToastContainer />
    </div>
  );
}

export default App;
